// siteTracker.js — anonymous visit statistics for the app's PUBLIC pages
// only (sign in, sign up, verify, reset, join, confirm email). The signed-in
// app is never tracked: `isTrackedPath` is the whole gate, and nothing here
// writes a cookie or anything else to the visitor's device.
//
// Sent to POST /api/site-visits (backend routes/siteVisitRoutes.js), which
// stores no IP and counts a visitor only within one day. Read on the Admin
// page's Website tab.
import { BACKEND_URL } from './config';

const PUBLIC_PATHS = [/^\/login\/?$/, /^\/verify\/?$/, /^\/confirm-email\/?$/, /^\/reset-password\/?$/, /^\/join\//];

export function isTrackedPath(path) {
  return PUBLIC_PATHS.some(re => re.test(path || ''));
}

function doNotTrack() {
  try {
    return navigator.doNotTrack === '1' || window.doNotTrack === '1' || navigator.globalPrivacyControl === true;
  } catch { return false; }
}

function send(payload) {
  if (doNotTrack()) return;
  const body = JSON.stringify({ site: 'app', screenW: window.screen?.width || 0, ...payload });
  const url = `${BACKEND_URL}/api/site-visits`;
  try {
    if (navigator.sendBeacon && navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' }))) return;
  } catch { /* fall through to fetch */ }
  try {
    fetch(url, { method: 'POST', body, headers: { 'Content-Type': 'text/plain' }, keepalive: true, credentials: 'omit' }).catch(() => {});
  } catch { /* never let statistics break a page */ }
}

function utmOf(search) {
  try {
    const q = new URLSearchParams(search || window.location.search);
    const utm = { source: q.get('utm_source'), medium: q.get('utm_medium'), campaign: q.get('utm_campaign') };
    return utm.source || utm.medium || utm.campaign ? utm : undefined;
  } catch { return undefined; }
}

// `path` may be a virtual page (the sign-up form is a mode of /login, so it
// is sent as /login/signup).
export function trackPageview(path, { force = false } = {}) {
  const real = window.location.pathname;
  if (!force && !isTrackedPath(real)) return;
  send({ event: 'pageview', path: path || real, referrer: document.referrer || '', utm: utmOf() });
}

export function trackClick(target) {
  if (!isTrackedPath(window.location.pathname)) return;
  send({ event: 'click', path: window.location.pathname, target: String(target || '').slice(0, 120) });
}
